<script lang="ts">
    import { IconShieldLockFilled } from "../../Components/Icons";
</script>

<div class="absolute bottom-[4px] right-[-4px] h-3 w-3">
    <IconShieldLockFilled font-size={10} />
</div>
